import React from 'react';
import { NEXT_PRICE, PROMO_END_AT } from '../data/config';
import { useCountdown } from '../hooks/useCountdown';
import { formatCountdown, getCuposPercent } from '../utils/promo';

/** Franja superior fina con mensajes que se desplazan hacia la izquierda. */
export function TopBar() {
  const timeLeft = useCountdown(PROMO_END_AT);
  const percent = getCuposPercent();
  const items = <>
      <span className="font-bold" data-id="element-233" data-mp="2qszow17f1wro">🎃 Prepará Halloween en familia</span>
      <Dot data-id="element-234" data-mp="2ltem1fp4l49o" />
      <span className="text-white/85" data-id="element-235" data-mp="2ltn2tiodctq5">2 tomos + 5 bonus</span>
      <Dot data-id="element-236" data-mp="2lu6g2m32qtxu" />
      {timeLeft && <>
          <span data-id="element-237" data-mp="2h251uumcit56">
            ⏰ Precio de lanzamiento termina en:{' '}
            <strong className="tabular-nums text-brand-orange" data-id="element-238" data-mp="2c3lc0j4msx7j">{formatCountdown(timeLeft)}</strong>
            <span className="ml-1.5 text-white/85" data-id="element-239" data-mp="39iz6k30xg9l2">· Después aumenta a {NEXT_PRICE}</span>
          </span>
          <Dot data-id="element-240" data-mp="34s8z8k8xxwnq" />
        </>}
      {percent !== null && <>
          <span className="text-white/90" data-id="element-241" data-mp="34q63djl3x9b3">
            <strong className="text-brand-orange" data-id="element-242" data-mp="24zfc5aebm0z">{percent}%</strong> de cupos tomados
          </span>
          <Dot data-id="element-243" data-mp="672vh780fesl" />
        </>}
    </>;

  // Cada mitad repite los mensajes para cubrir pantallas anchas; la segunda mitad permite el bucle continuo.
  const half = (hidden: boolean) => <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center gap-4 pr-4" data-id="element-244" data-mp="3tj3tgemd7dl8">
      {items}
      {items}
      {items}
    </div>;
  return <div className="sticky top-0 z-50 w-full bg-brand-violet text-white" data-id="element-245" data-mp="3eoz90q1wvjnv">
      <div className="flex items-center" data-id="element-246" data-mp="3jn0svd75vn0e">
        <div className="group relative min-w-0 flex-1 overflow-hidden py-1.5" data-id="element-247" data-mp="35m7x6p54ilvp">
          <div className="animate-marquee flex w-max whitespace-nowrap text-[13px] group-hover:[animation-play-state:paused] md:text-sm" data-id="element-248" data-mp="35oawy0w2vtdm">
            {half(false)}
            {half(true)}
          </div>
        </div>
        <a href="#oferta" className="mx-2 my-1 shrink-0 whitespace-nowrap rounded-lg border-b-2 border-brand-orangeDark bg-brand-orange px-2.5 py-1 text-xs font-bold text-brand-violet transition-[transform,background-color] duration-150 ease-out hover:-translate-y-px hover:bg-brand-orangeLight focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-brand-violet md:mx-4" data-id="element-249" data-mp="18tee80hr1ps0">
          VER KIT →
        </a>
      </div>
    </div>;
}
function Dot() {
  return <span aria-hidden="true" className="text-brand-orange" data-id="element-250" data-mp="1q27791lslmcz">
      ✦
    </span>;
}